import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetProfessionalActivitiesTransactionsUseCase extends UseCase {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute() {
    const [error, response] = await this._httpTransactionsRepository.getProfessionalActivities()

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}
